import { UPDATE_CATALOG_ITEM_METHOD } from 'modules/catalogTable/constants';
import { ModalHeader } from 'ui/modal';
import { ProgressBar } from './ProgressBar';
import { ModalHeaderContent, ModalHeaderDescription } from './CatalogForm.styled';

// type Props = {
//   tableName: string,
//   isCatalogCollectionsFlagOn: boolean,
//   steps: Array<Object>,
//   step: number,
//   skipDefine: boolean,
//   updateMethod: ?string,
// };

const CatalogFormModalHeader = ({
  skipDefine,
  step,
  steps,
  updateMethod,
  tableName,
  isCatalogCollectionsFlagOn,
}) => {
  const title =
    updateMethod === UPDATE_CATALOG_ITEM_METHOD.JSON
      ? `Create or update item in ${tableName}`
      : `Bulk update to ${tableName}`;
  const updateText = 'Updating an item with an existing key will replace it within the catalog';

  const getDescription = () => {
    switch (step) {
      case 1:
        return updateText;
      case 2:
      case 3:
        return skipDefine
          ? null
          : 'Review suggestions for the field types and confirm they&apos;re correct. Once saved, field types cannot be redefined';
      default:
        return null;
    }
  };
  const description = getDescription();

  return (
    <ModalHeader>
      <ModalHeaderContent>
        <div>
          <p>{title}</p>
          {description && <ModalHeaderDescription>{description}</ModalHeaderDescription>}
        </div>
        {isCatalogCollectionsFlagOn && <ProgressBar currentStep={step} steps={steps} />}
      </ModalHeaderContent>
    </ModalHeader>
  );
};
export default CatalogFormModalHeader;
